import { type ComponentPropsWithoutRef, memo } from 'react';

import { type Clip } from '@air/api/types';
import { FileExtensionPreview, getExtStyles } from '@air/component-file-extension-preview';
import { cn } from '@air/utils-tailwind';

type AssetGalleryCardFailedTranscodeProps = Pick<Clip, 'ext'> & Pick<ComponentPropsWithoutRef<'div'>, 'className'>;

export const AssetGalleryCardFailedTranscode = memo(({ className, ext }: AssetGalleryCardFailedTranscodeProps) => {
  return (
    <div
      className={cn('flex flex-1 flex-col items-center justify-center', className)}
      style={{
        /**
         * Todo: get rid of theme. to do that though,
         * getExtStyles (and all underlying functions) will need to be refactored
         */
        backgroundColor: getExtStyles(ext).bgColor,
      }}
    >
      <FileExtensionPreview
        ext={ext}
        text="No preview available"
        color="color"
        size="medium"
        className="grow justify-center"
      />
    </div>
  );
});

AssetGalleryCardFailedTranscode.displayName = 'AssetGalleryCardFailedTranscode';
